// extracted by mini-css-extract-plugin
export default {"terms_privacy2":"Privacy2_terms_privacy2__QXqOZ"};